import axiosX from './axiosX'

import { readAppSetting } from '../libs/appSettingUtils.js';
const appSetting = readAppSetting();

/**
 * 登录单位
 * @param params
 */
export function login(params = {}, onSuccess, onFail) {
  axiosX.postWithCustomToken(`${appSetting.khlis}login/2`, params.password, params,
    (result) => {
      // if (!result || !result.data || !result.data.items || result.data.items.length == 0) {
      //   throw Error('登陆异常！');
      // }
      if (!result.success) {
        onFail(new Error(result.errorMsg));
        return;
      }
      if ($.isFunction(onSuccess)) {
        onSuccess(result.data)
      }
    },
    onFail
  );
}

/**
 * 获取区域机构
 * @param orgId
 * @returns {Promise}
 */
export function getAreaOrgs(orgId, onSuccess, onFail) {
  axiosX.get(`${appSetting.khlis}request/barcode/queryCtrAreaContractOrgs/${orgId}/2`, null,
    (result) => {
      if (!result.success) {
        onFail(new Error(result.errorMsg));
        return;
      }
      if ($.isFunction(onSuccess)) {
        onSuccess(result.data.items)
      }
    }, onFail);
}

/**
 * 获取就诊类型
 * @param orgId
 * @param onSuccess
 * @param onFail
 */
export function getTreatmentTypes(orgId, onSuccess, onFail) {
  axiosX.get(`${appSetting.khlis}dic/dictcodes/2/${orgId}/10`,
    {
      page_no : 0,
      page_num : 0,
      status : 1
    },
    (result) => {
    if (!result.success) {
      onFail(new Error(result.errorMsg));
      return;
    }
    if ($.isFunction(onSuccess)) {
      onSuccess(result.data.items)
    }
  }, onFail);
}

export function getDoctors(orgId, onSuccess, onFail) {
  axiosX.get(`${appSetting.khlis}dic/doctors/2/${orgId}`,
    {
      page_no : 0,
      page_num : 0,
      //status : 1
    },
    (result) => {
      if (!result.success) {
        onFail(new Error(result.errorMsg));
        return;
      }
      if ($.isFunction(onSuccess)) {
        onSuccess(result.data.items)
      }
    }, onFail);
}

/**
 * 获取审请科室
 * @param orgId
 * @param userId
 * @param onSuccess
 * @param onFail
 */
export function getDepartments(orgId, userId, onSuccess, onFail) {
  axiosX.get(`${appSetting.khlis}dic/departments/2/${orgId}`,
    {
      page_no : 0,
      page_num : 0,
      //status : 1,
      users_in_department: userId
    },
    (result) => {
      if (!result.success) {
        onFail(new Error(result.errorMsg));
        return;
      }
      if ($.isFunction(onSuccess)) {
        onSuccess(result.data.items)
      }
    }, onFail);
}

/**
 * 更改密码
 * @param orgId
 * @param params
 * @param onSuccess
 * @param onFail
 */
export function updatePwd(orgId, userId, params = {}, onSuccess, onFail) {
  axiosX.put(`${appSetting.khlis}system/user/userInfo/pwd/2/${orgId}/${userId}`,
    params,
    (result) =>{
      if (!result.success) {
        onFail(new Error(result.errorMsg));
        return;
      }
      if ($.isFunction(onSuccess)) {
        onSuccess();
      }
    }, onFail);
}

/**
 * 获取用户系统参数配置
 * @param orgId
 * @param userId
 * @param params
 * @param onSuccess
 * @param onFail
 */
export function getUserSetting(orgId, userId, onSuccess, onFail) {
  axiosX.get(`${appSetting.khlis}testReport/userSetting/1/${orgId}/${userId}`,
    null,
    (result) =>{
      if (!result.success) {
        onFail(new Error(result.errorMsg));
        return;
      }
      if ($.isFunction(onSuccess)) {
        onSuccess(result.data.items);
      }
    }, onFail);
}

/**
 * 保存用户系统参数配置
 * @param orgId
 * @param userId
 * @param params
 * @param onSuccess
 * @param onFail
 */
export function saveUserSetting(orgId, userId, params={}, onSuccess, onFail) {
  axiosX.post(`${appSetting.khlis}testReport/userSetting/1/${orgId}/${userId}`,
    params,
    (result) =>{
      if (!result.success) {
        onFail(new Error(result.errorMsg));
        return;
      }
      if ($.isFunction(onSuccess)) {
        onSuccess();
      }
    }, onFail);
}

/**
 * 图片验证码
 * @param onSuccess
 * @param onFail
 */
export function getCaptcha(onSuccess, onFail) {
  axiosX.get(`${appSetting.khlis}captcha`,
    null,
    (result) =>{
      if (!result.success) {
        onFail(new Error(result.errorMsg));
        return;
      }
      if ($.isFunction(onSuccess)) {
        onSuccess(result.data);
      }
    }, onFail);
}

/**
 * 获取一次性密钥
 * @param onSuccess
 * @param onFail
 */
export function getSecretKey(onSuccess, onFail) {
  axiosX.get(`${appSetting.khlis}secretKey`,
    null,
    (result) =>{
      if (!result.success) {
        onFail(new Error(result.errorMsg));
        return;
      }
      if ($.isFunction(onSuccess)) {
        onSuccess(result.data);
      }
    }, onFail);
}

//dic/departments/

//
export default {
  login,
  getAreaOrgs,
  getTreatmentTypes,
  getDoctors,
  getDepartments,
  updatePwd,
  getUserSetting,
  saveUserSetting,
  getCaptcha,
  getSecretKey,
  // computed:{
  //   ...mapGetters(['userInfo'])
  // }
}



// WEBPACK FOOTER //
// ./src/api/apiSystem.js